import React from 'react';
import { ArrowRight, Shield, Clock, Award } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo, images } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    { icon: Shield, text: 'Certificados Microsoft' },
    { icon: Clock, text: '+25 Años de Experiencia' },
    { icon: Award, text: 'Socios HP & Microsoft' }
  ];

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.hero})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 right-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 left-10 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 border border-blue-500/30 rounded-full text-blue-300 text-sm mb-8 animate-pulse">
            <Shield size={16} />
            <span>Socios certificados Microsoft & HP</span>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Soluciones en{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-orange-400">
              Soporte IT
            </span>{' '}
            de Primer Nivel
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-slate-300 mb-8 leading-relaxed">
            Especialistas en <strong className="text-orange-400">Networking</strong>,{' '}
            <strong className="text-blue-400">Windows Server</strong> y{' '}
            <strong className="text-white">Soporte a Usuarios</strong>. Contratos de soporte personalizados que se ajustan a las necesidades de cada cliente.
          </p>

          {/* Feature badges */}
          <div className="flex flex-wrap gap-4 mb-10">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-2 px-4 py-2 bg-slate-800/60 border border-slate-700/50 rounded-lg text-slate-200"
              >
                <feature.icon size={18} className="text-orange-400" />
                <span className="text-sm font-medium">{feature.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-orange-500/25 group"
            >
              Solicitar Cotización
              <ArrowRight className="ml-2 transition-transform group-hover:translate-x-1" size={20} />
            </Button>
            <Button
              onClick={() => document.querySelector('#servicios')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              size="lg"
              className="border-slate-500 text-slate-200 hover:bg-slate-800 hover:text-white px-8 py-6 text-lg transition-all duration-300"
            >
              Ver Servicios
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-slate-400 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-orange-400 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
